import { IAuditPagedRequest } from '../../../../model/apm/audit/request/audit-paged-request';
import { IAuditResponse } from '../../../../model/apm/audit/response/audit-response';

export type AuditSearchState = {
    parameters: IAuditPagedRequest;
    searchTrigger: number;
    drawer: { open: boolean; audit?: IAuditResponse };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
}

export const AuditSearchReducer = (state: AuditSearchState, action: any): AuditSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, audit: payload } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
